let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4z9Sd")).then(() => parcelRequire('gOhSj'));